import { render, staticRenderFns } from "./submitForm.vue?vue&type=template&id=6dd62152&scoped=true&"
import script from "./submitForm.vue?vue&type=script&lang=js&"
export * from "./submitForm.vue?vue&type=script&lang=js&"
import style0 from "./submitForm.vue?vue&type=style&index=0&id=6dd62152&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd62152",
  null
  
)

export default component.exports